// Custom.
import I18n from "@vocollege/app/dist/modules/Services/I18n";
import { GeneralObject } from "@vocollege/app/dist/global";
import {
  DownloadExcelButtonProps,
  Sheet,
} from "@vocollege/components/dist/DownloadExcelButton";
import { getStatisticsTotal } from "services/Utils";
import { getSummaryEducatorType, sortByTitle, sortByLabel } from "../Utils";

// export const getSummary = (parsedData: any, variables: any) => {
//   const result: GeneralObject = {};
//   if (!("items" in parsedData)) {
//     return [];
//   }
//   Object.values(parsedData.items)
//     .sort(sortByTitle)
//     .forEach((item: any) => {
//       Object.values(item.children)
//         .sort(sortByTitle)
//         .forEach((child: any) => {
//           Object.keys(child.educations).forEach((educationId: string) => {
//             let education = child.educations[educationId];
//             if (!(educationId in result)) {
//               result[educationId] = {
//                 label: I18n.get.diploma.diplomaTypes[education.diploma_type],
//                 note:
//                   education.diploma_type !== "yh" &&
//                   I18n.get.diploma.education[education.diploma_type][
//                     education.education
//                   ],
//                 value: education.total,
//               };
//             }
//           });
//         });
//     });
//   return Object.keys(result)
//     .sort()
//     .map((v: string) => {
//       return {
//         label: result[v].label,
//         note: result[v].note,
//         value: result[v].value,
//       };
//     });
// };

export const getExcelData = (data: any, parsedData: any, variables: any) => {
  if (!data || !parsedData?.items || parsedData?.items?.length === 0) {
    return null;
  }
  const result: DownloadExcelButtonProps = {
    filename: I18n.get.diploma.label,
    sheets: [],
  };

  let commonHead = [
    [
      {
        richText: [
          {
            font: {
              size: 16,
              bold: true,
            },
            text: I18n.get.diploma.label,
          },
        ],
      },
      "",
      `${I18n.get.misc.created_at} ${data?.certStatisticsDiplomas.createdAt}\n${variables?.from} - ${variables?.to}`,
    ],
    [],
    [],
    [
      {
        richText: [
          {
            font: {
              size: 10,
              bold: true,
            },
            text: I18n.get.vocertStatistics.total,
          },
        ],
      },
      "",
      parsedData.total,
    ],
  ];

  let summarySheet: Sheet = {
    name: I18n.get.vocertStatistics.summary,
    rows: [...commonHead],
  };

  Object.keys(parsedData.itemsPerEducation)
    .sort((a, b) => sortByLabel(a, b, parsedData.itemsPerEducation))
    .forEach((key: string) => {
      const education = parsedData?.itemsPerEducation[key];
      summarySheet.rows?.push(["", "", ""]);
      let label = education.label;
      if (education.note) {
        label = `${label}\n${education.note}`;
      }
      summarySheet.rows?.push([
        {
          richText: [
            {
              font: {
                size: 10,
              },
              text: label,
            },
          ],
        },
        "",
        education.value,
      ]);
    });

  result.sheets?.push(summarySheet);

  let summaryEducatorTypeSheet: Sheet = {
    name: I18n.get.vocertStatistics.perEducatorType,
    rows: [...commonHead],
  };

  summaryEducatorTypeSheet.rows?.push([
    {
      richText: [
        {
          font: {
            size: 10,
          },
          text: I18n.get.vocertStatistics.perEducatorTypeNote,
        },
      ],
    },
    "",
    "",
  ]);

  Object.keys(parsedData.itemsPerEducatorType)
    .sort((a, b) => sortByLabel(a, b, parsedData.itemsPerEducatorType))
    .forEach((key: string) => {
      const education = parsedData.itemsPerEducatorType[key];

      summaryEducatorTypeSheet.rows?.push(["", "", ""]);
      let label = education.label;
      if (education.note) {
        label = `${label}\n${education.note}`;
      }
      summaryEducatorTypeSheet.rows?.push([
        {
          richText: [
            {
              font: {
                size: 10,
              },
              text: label,
            },
          ],
        },
        "",
        education.value,
      ]);
    });

  result.sheets?.push(summaryEducatorTypeSheet);

  let byGroupSheet: Sheet = {
    name: I18n.trans(I18n.get.vocertStatistics.perItem, {
      item: I18n.get.group.categories[variables?.groupBy].toLowerCase(),
    }),
    rows: [...commonHead],
  };

  Object.values(parsedData.items).forEach((v: any) => {
    byGroupSheet.rows?.push(["", "", ""]);

    let title = v.title;

    if (v.note) {
      title = `${title}\n${v.note}`;
    }

    byGroupSheet.rows?.push([
      {
        richText: [
          {
            font: {
              size: 12,
              bold: true,
            },
            text: title,
          },
        ],
      },
      "",
      v.total,
    ]);

    Object.values(v.children).forEach((v: any) => {
      if (variables?.groupBy === "region") {
        byGroupSheet.rows?.push([
          {
            richText: [
              {
                font: {
                  size: 10,
                  bold: true,
                },
                text: v.title,
              },
            ],
          },
          "",
          v.total,
        ]);
      }

      Object.values(v.educations).forEach((education: any) => {
        let educationTitle = education.title;

        if (education.subtitle) {
          educationTitle = `${educationTitle}\n${education.subtitle}`;
        }

        byGroupSheet.rows?.push([
          {
            richText: [
              {
                font: {
                  size: 10,
                },
                text: educationTitle,
              },
            ],
          },
          "",
          education.total,
        ]);

        if (variables?.groupBy !== "educator") {
          Object.values(education.educators).forEach((educator: any) => {
            byGroupSheet.rows?.push([
              {
                richText: [
                  {
                    font: {
                      size: 8,
                    },
                    text: `- ${educator.title}`,
                  },
                ],
              },
              "",
              educator.total,
            ]);
          });
        }
      });
    });
  });

  result.sheets?.push(byGroupSheet);

  return result;
};
